import { useSyncExternalStore } from 'react';
import { NapakaApi } from '../api/napaka';
import { seja } from '../seja/seja';

/**
 * Žeton skrbniške seje (dobi se s kodo TOTP, glej SkrbniskaSeja na strežniku). Samo v pomnilniku: ob osvežitvi
 * strani, odjavi ali poteku (403 SKRBNIK_KODA) je treba kodo vpisati znova.
 */
let zeton: string | null = null;
const poslusalci = new Set<() => void>();

function nastavi(z: string | null) {
  zeton = z;
  poslusalci.forEach((p) => p());
}

export const skrbniskiZeton = {
  dobi: () => zeton,
  nastavi,
  pozabi: () => nastavi(null),
  naroci: (p: () => void) => {
    poslusalci.add(p);
    return () => poslusalci.delete(p);
  },
};

// odjava pobriše tudi skrbniško sejo
seja.naroci(() => {
  if (seja.dobi().status !== 'prijavljen' && zeton) {
    nastavi(null);
  }
});

export function useSkrbniskiZeton(): string | null {
  return useSyncExternalStore(skrbniskiZeton.naroci, skrbniskiZeton.dobi);
}

/** Glava za klice /api/skrbnik/* (openapi-fetch {@code headers}). */
export function glave(): Record<string, string> {
  return zeton ? { 'X-Hera-Skrbnik': zeton } : {};
}

/** Skrbniška seja je potekla (strežnik zahteva novo kodo): pozabi žeton, da se pokaže vnos kode. */
export function obNapaki(e: unknown): void {
  if (e instanceof NapakaApi && e.koda === 'SKRBNIK_KODA') {
    nastavi(null);
  }
}
